import React, {useState, useEffect, useRef, Fragment} from "react";
import "./HistoryExamine.scss";
import {Button, Row, Space, Spin, Tooltip, Typography} from "antd";
import Icons from "assets/icons";
import Table from "antd/es/table";
import {listHistoryColumns} from "./config";
import {useAppDispatch, useAppSelector} from "redux/hooks";
import ModalCustom from "components/common/ModalCustom/ModalCustom";
import AnalysisModal from "components/common/PrintReceipt/AnalysisModal/AnalysisModal";
import {setActiveKey} from "redux/reducer/common";
import NurseOutModal from "../PrintReceipt/NurseOutModal/NurseOutModal";
import ExamOutModal from "../PrintReceipt/ExamOutModal/ExamOutModal";
import PrintForm from "pages/Refractive/InforDetails/PrintForm/PrintForm";
import dayjs from "dayjs";
import {examOutService} from "api";
import ExanRegBill from "pages/Receive/Received/components/ExamRegBill/ExamRegBill";
import {setIdReceipt, setInDetail} from "redux/reducer/pending";
import {setIdPhieu, setIdReceiptNurseOut} from "redux/reducer/nurseOut";
import DiagnoseModal from "components/common/PrintReceipt/DiagnoseModal/DiagnoseModal";
import {setIdReceiptExamOut} from "redux/reducer/examination";
import ElectroModal from "../PrintReceipt/ElectroPrintModal/ElectroPrintModal";
import {setIdElectrocardiography} from "redux/reducer/electrocardiography";
import {setIdPrintXN} from "redux/reducer/reduxCommon";
import {setIdDiagnose, setIsCallResultDiagnose} from "redux/reducer/diagnose";
import {setIdConsultantAndFragment} from "redux/reducer/consultantAndFragment";
import ConsulantAndFragtmentPrint from "components/common/PrintReceipt/ConsulantAndFragtmentPrint/ConsulantAndFragtmentPrint";
import TreatmentInfo from "./NoiTruHis/TreatmentInfo/TreatmentInfo";
import DetailInfo from "./NoiTruHis/DetailInfo/DetailInfo";

const colors = [
  "#ff4d4f",
  "#ffc53d",
  "#ffa940",
  "#a0d911",
  "#ff7a45",
  "#13c2c2",
  "#1677ff",
  "#9254de",
];
const getListHistoryMap = histories => {
  const groups = new Map();
  histories.forEach(htr => {
    // Lấy ngày tháng từ thời gian tạo
    const ngayTao = new Date(htr.thoiGianTao).toLocaleDateString();

    // Kiểm tra xem đã có mảng cho ngày này chưa
    if (groups.has(ngayTao)) {
      // Nếu đã tồn tại, thêm phần tử vào mảng tương ứng
      groups.get(ngayTao).push(htr);
    } else {
      // Nếu chưa tồn tại, tạo mảng mới và thêm phần tử đầu tiên vào
      groups.set(ngayTao, [htr]);
    }
  });

  groups.forEach(htr => {
    htr.sort((a, b) => {
      const timeA: any = new Date(a.thoiGianTao);
      const timeB: any = new Date(b.thoiGianTao);

      return timeB - timeA;
    });
  });
  const sortGroup = new Map([...groups].sort((a, b) => a[0] - b[0])).values();

  return [...sortGroup];
};
const HistoryExamine = props => {
  //
  const {tabName} = props;
  const getBorderLeft = index => {
    let res = colors[index % 8];
    return res;
  };

  //tab
  const activeTab = useAppSelector(e => e.common.activeTab);

  // redux
  let dispatch = useAppDispatch();
  const idPK = useAppSelector(state => state.common.idPhieuKham);

  //state
  const [loading, setLoading] = useState<boolean>(false);
  const [histories, setHistories] = useState<any>(null);

  // functions
  const analysisRef = useRef<any>();
  const diagnoseRef = useRef<any>();
  const nurseOutRef = useRef<any>();
  const examOutRef = useRef<any>();
  const refractionRef = useRef<any>();
  const receiptRef = useRef<any>();
  const electroRef = useRef<any>();
  const tuVanRef = useRef<any>();
  const phauThuatRef = useRef<any>();
  const ptRef = useRef<any>();
  const noiTruRef = useRef<any>();

  const fetchHistoriesById = async () => {
    setHistories([]);
    if (idPK == null) {
      // notification.error({message: "chưa có thông tin phiếu khám!"})
      return;
    }
    try {
      setLoading(true);
      let response = await examOutService.getHistoriesByIdPK({
        idPhieuKham: idPK,
      });
      const newRes = response.map(item => {
        return {...item, key: item.loaiPhieu};
      });
      const res = getListHistoryMap(newRes);

      setHistories(res);
      setLoading(false);
    } catch (err) {
      setHistories(null);
      // notification.error({message: "Lỗi xảy ra khi lấy lịch sử khám bệnh!"})
      setLoading(false);
    }
  };

  const handleOpenDetailReceipt = record => {
    if (record.loaiPhieu === 2) {
      dispatch(setIdReceiptNurseOut(record.idPhieu));
      nurseOutRef?.current.openModal();
    } else if (record.loaiPhieu === 3) {
      examOutRef?.current.openModal();
      dispatch(setIdReceiptExamOut(record.idPhieu));
    } else if (record.loaiPhieu === 4) {
      dispatch(setIdPrintXN(record.idPhieu));
      analysisRef.current?.openModal();
    } else if (record.loaiPhieu === 5) {
      dispatch(setIdDiagnose(record.idPhieu));
      diagnoseRef.current.openModal();
      dispatch(setIsCallResultDiagnose(true));
    } else if (record.loaiPhieu === 1) {
      refractionRef.current.openModal();
      dispatch(setIdReceipt(record.idPhieu));
      dispatch(setInDetail(false));
    } else if (record.loaiPhieu === 0) {
      receiptRef.current.openModal();
      receiptRef.current.setIdPK(record.idPhieu);
    } else if (record.loaiPhieu === 6) {
      electroRef.current?.openModal();
      dispatch(setIdElectrocardiography(record.idPhieu));
    } else if (record.loaiPhieu === 7) {
      tuVanRef.current?.openModal();
      dispatch(setIdConsultantAndFragment(record.idPhieu));
    } else if (record.loaiPhieu === 8) {
      // dispatch(setIdDetailSurgery(record.idPhieu));
      ptRef.current?.setId(record.idPhieu);
      ptRef.current?.setOpenModal(true);
      // phauThuatRef.current?.openModal();
      // dispatch(setIdConsultantAndFragment(record.idPhieu));
    } else if (record.loaiPhieu === 9) {
      // dispatch(setIdDetailSurgery(record.idPhieu));
      // noiTruRef.current?.openModal();
      noiTruRef.current?.setId(record.idPhieu);
      noiTruRef.current?.setOpenModal(true);
      // dispatch(setIdConsultantAndFragment(record.idPhieu));
    }
  };

  listHistoryColumns.map(e => {
    if (e.key == "action") {
      e.render = (_, record: {idPhieu: number}, index) => {
        return (
          <Space>
            <Tooltip title="Chi tiết phiếu">
              <Button
                onClick={() => handleOpenDetailReceipt(record)}
                icon={<Icons.edit />}
                type="text"
              ></Button>
            </Tooltip>
          </Space>
        );
      };
    }
  });
  // side effect
  useEffect(() => {
    console.log(idPK);
    if (idPK != null || idPK) {
      fetchHistoriesById();
    } else if (tabName && idPK == null) {
      dispatch(setActiveKey(tabName));
    }
  }, [idPK, activeTab]);

  return (
    <Spin spinning={loading}>
      <div>
        <div className="container">
          <>
            {histories?.map((it, index) => {
              return (
                <div style={{padding: "8px 0"}} key={index}>
                  <div
                    style={{
                      borderLeft: `4px solid ${getBorderLeft(index)}`,
                      padding: "0 4px",
                    }}
                  >
                    <Row style={{marginBottom: "4px"}}>
                      <Typography.Text strong>
                        {it[0].thoiGianTao
                          ? dayjs(it[0].thoiGianTao).format("DD/MM/YYYY")
                          : ""}
                      </Typography.Text>
                    </Row>
                    <Table
                      columns={listHistoryColumns}
                      dataSource={it}
                      pagination={false}
                      loading={loading}
                      bordered
                      onRow={record => ({
                        onDoubleClick: () => handleOpenDetailReceipt(record),
                      })}
                    />
                  </div>
                </div>
              );
            })}
          </>
        </div>
      </div>
      {/* Xét nghiệm */}
      <ModalCustom
        wrapClassName="modal-print-form"
        ref={analysisRef}
        centered
        width={1000}
      >
        <AnalysisModal />
      </ModalCustom>
      {/* Chẩn đoán hình ảnh */}
      <ModalCustom ref={diagnoseRef} centered width={1000}>
        <DiagnoseModal onAdd={listHistoryColumns} />
      </ModalCustom>
      {/* Nội trú */}
      <ModalCustom ref={nurseOutRef} width={1000} centered>
        <NurseOutModal />
      </ModalCustom>
      {/* Ngoại trú */}
      <ModalCustom ref={examOutRef} width={1000} centered>
        <ExamOutModal />
      </ModalCustom>
      {/*modal khúc xạ */}
      <ModalCustom ref={refractionRef} centered width={1000}>
        <PrintForm />
      </ModalCustom>
      <ExanRegBill modalRef={receiptRef} />
      {/* Điện tim */}
      <ModalCustom ref={electroRef} centered width={1000}>
        <ElectroModal />
      </ModalCustom>
      {/* Tư vấn và điều trị */}
      <ModalCustom ref={tuVanRef} centered width={1000}>
        <ConsulantAndFragtmentPrint />
      </ModalCustom>
      {/* Phẫu thuật */}
      {/* <ModalCustom ref={phauThuatRef} width={1500}> */}
      {/* <PrintPhieuPT /> */}
      {/* </ModalCustom> */}
      <DetailInfo ref={ptRef} />

      {/* <ModalCustom ref={phauThuatRef} width={1000}>
        <PrintPhieuPT />
      </ModalCustom> */}
      {/* giấy phẫu thuật */}
      {/* <ModalCustom ref={noiTruRef} width={1500}> */}
      <TreatmentInfo ref={noiTruRef} />
      {/* </ModalCustom> */}
    </Spin>
  );
};

export default HistoryExamine;
